module.exports = __webpack_public_path__ + "static/doc-annotations-macbook-af2997a744c131f326f9391b52b5cf69.png";